const mutations = {
  setPageConfig(state, payload) {
    state.pageConfig = payload
    console.log(state.pageConfig)
  }
}

export default mutations


// WEBPACK FOOTER //
// ./src/store/mutations.js